import React from 'react'
import styles from './skills.module.css'

  const DATA=[
    {
      header:"Frontend",
      parameters:[{name:"HTML", length:100},{name:"CSS", length:90},
               {name:"JavaScript",length:85},{name:"TypeScript",length:85}]
    },
    {
      header:"Backend/Framework",
      parameters:[{name:"Node.js(Express)", length:90},{name:"React, Redux", length:95},
                {name:"Google Firebase", length:70},]
    },
    {
      header:"Design",
      parameters:[{name:"Responsible Design", length:85},{name:"Material UI", length:85},{name:"React Bootstrap", length:70}]
    },
    {
      header:"Database",
      parameters:[{name:"MySQL",length:70},{name:"MongoDB", length:90}]
    }
  ]

export default function Skills({position}) {
    
  return (
DATA.map((d,index)=>(
    <div key={index} className={styles.skill}>
      <div className={styles.header}>{d.header}</div>
    {d.parameters.map((p,index)=>(
      <div key={index}>
       <div key={index} className={styles.name}>{p.name}</div>
       <div className={styles.bar}>
         <div className={styles.parameter} style={{width:position < 0 ? `${p.length}%`: "0%"}}></div>
       </div>
      </div>
     ))}
    </div>
    ))
  )
}
